module.exports = __webpack_public_path__ + "img/8.f8ce39a4.jpg";